
var dlbConsumerRequire, dlbConsumerIds;
__webpack_require__.linkDlb = function(require, ids) {
  dlbConsumerRequire = require;
  dlbConsumerIds = ids;
}

window["__webpack_require_head-dlb/static-1.4994/bundle.production.js__"] = window["__webpack_require_head-dlb/bundle.production.js__"] = __webpack_require__;

__webpack_require__.dlbcr = function(id) {
  if (!dlbConsumerRequire) {
    throw new Error('dlb consumer not properly linked');
  }
  var otherId = dlbConsumerIds[id];
  if (typeof otherId === 'undefined') {
    throw new Error('dlb consumer does not provide module ' + id);
  }
  return dlbConsumerRequire(otherId);
}
